import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "../../annotations";
import { CampaignStatsResponse } from "./dtos";

const CAMPAIGN_SERVICE = `${Constants.API_URL}/bedrock/campaigns`;

export class CampaignServices {
  @scCatchServiceException()
  static async getCampaignStats(campaignId: number | string): Promise<CampaignStatsResponse> {
    const { data } = await axios.get<CampaignStatsResponse>(`${CAMPAIGN_SERVICE}/${campaignId}/stats`);
    return data;
  }
}
